import { createTheme } from '@mui/material/styles';
import { esES } from '@mui/material/locale';
declare module '@mui/material/styles' {
	interface Palette {
		blue: Palette['primary'];
		yellow: Palette['primary'];
	}

	interface PaletteOptions {
		blue?: PaletteOptions['primary'];
		yellow?: PaletteOptions['primary'];
	}
}
const theme = createTheme(
	{
		palette: {
			primary: {
				main: '#744CB4',
				dark: '#352560',
				light: '#E8E0F4',
			},
			secondary: {
				main: '#744CB4',
				dark: '#5C3A8F',
			},
			success: {
				main: '#3ABE21',
				dark: '#079531',
				light: '#D0F0C9',
				contrastText: '#ffffff',
			},
			warning: {
				main: '#E35700',
				dark: '#E35700',
				light: '#FAE295',
				contrastText: '#FFA800',
			},
			error: {
				main: '#DD0528',
				dark: '#DD0528',
				light: '#FFE2E5',
			},
			info: {
				main: '#744CB4',
				light: '#E8E0F4',
				dark: '#352560',
				contrastText: '#ffffff',
			},
			background: {
				default: '#f8f8f8',
			},
			grey: {
				'200': '#CBCBCB',
			},
			blue: {
				main: '#744CB4',
				light: '#E8E0F4',
			},
			yellow: {
				main: '#dcc97c',
				light: '#fcf3ce',
				dark: '#d3bd63',
			},
		},
	},
	esES
);

export const themBackdrop = createTheme({
	components: {
		MuiBackdrop: {
			styleOverrides: {
				root: {
					zIndex: 99999,
					backgroundColor: 'rgba(0,0,0,0.6)',
				},
			},
		},
	},
});

export default theme;
